import { render, staticRenderFns } from "./StepPaymentMethod.vue?vue&type=template&id=5153ec5e"
import script from "./StepPaymentMethod.vue?vue&type=script&lang=js"
export * from "./StepPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./StepPaymentMethod.vue?vue&type=style&index=0&id=5153ec5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports